import { useState } from "react";
import { IconClose, IconSearch } from "../../icons";
import { Container } from "./styles";

interface FilterProps {
    searchTerm?: string,
    setSearchTerm?: any,
}

export default function ApplicantsFilter(
    {
        searchTerm,
        setSearchTerm,
    }: FilterProps) {

    const [ DTOSearch, setDTOSearch ] = useState<any>(searchTerm || '');

    function handleOnChanges(value: any) {
        setDTOSearch(value)
        setSearchTerm(value)
    }

    function clearSearch() {
        setDTOSearch('')
        setSearchTerm('')
    }

    function searchKeyPressed(event: any) {
        if (event.key === 'Enter') {
            setSearchTerm(DTOSearch)
        }
    }

    return (
        <Container>
            <div className="search">
                <div
                    className="buscar"
                    onClick={() => setSearchTerm(DTOSearch)}
                >
                    <IconSearch/>
                </div>
                <input
                    placeholder="Pesquisar por nome"
                    onChange={(e) => handleOnChanges(e.target.value)}
                    onKeyDown={(e) => searchKeyPressed(e)}
                    value={DTOSearch}
                />
                {
                    DTOSearch &&
                    <div
                        className="clean-search"
                        onClick={() => clearSearch()}
                    >
                        <IconClose />
                    </div>
                }
            </div>
        </Container>
    )
}

